'use client';

function camelToKebabCase(value) {
  return value.replace(/[A-Z]/g, function (letter) {
    return "-".concat(letter.toLowerCase());
  });
}

export { camelToKebabCase };